import { Typography } from '@material-ui/core';
import { attributes, refTo } from '@type-r/models';
import { useIO, useModel } from '@type-r/react';
import { asCurrency, div, Flex, Loading, Page, SearchInput, SmallTile, TilesList, Toolbar, SelectSortBy, useLinkedQueryParam } from 'lqx-react';
import * as React from 'react';
import { useMemo } from 'react';
import { globalStore, localUserInfo } from 'api';
import { DebthSummary } from './api';
import { CustomerDebthList } from './details';
import { UploadSoaButton } from './dialogs';

const State = attributes({
    customerDebths: [DebthSummary],
    selected: refTo(DebthSummary),
    sortBy: {
        name: 'amount',
        isAsc: false
    },
    filter: ''
})

export const StatementOfCustomer = () => {
    const state = useModel(State);
    const isCompaniesReady = useIO(() => globalStore.companies.fetch());
    const $relationshipId = useLinkedQueryParam("relationshipId");

    const isReady = useIO(async () => {
        await state.customerDebths.fetch({
            params: state.filter
                ? { searchString: state.filter }
                : {}
        });
        state.selected = $relationshipId.value ? state.customerDebths.find(x => x.id == $relationshipId.value) : state.customerDebths.first();
    }, [state.filter]);

    const filtered = useMemo(() =>
        state.customerDebths.models.sort(DebthSummary.comparator(state.sortBy.name as any, state.sortBy.isAsc))
        , [state.filter, state.sortBy['_changeToken'], state.customerDebths['_changeToken']]);

    return isCompaniesReady ?
        <Page
            menuWidth={530}
            maxWidth="xl"
            left={
                <>
                <UploadSoaButton/>
                    <Toolbar>
                        <SearchInput
                            $value={state.$.filter}
                            placeholder="Filter by Company Name, Invoice No, Customer External ID"
                        />
                        <SelectSortBy
                            $attr={state.sortBy.$.name}
                            $asc={state.sortBy.$.isAsc}
                            options={sortSummaryOptions}
                        />
                    </Toolbar>
                    <VerticalSpace />

                    {!isReady ?
                        <Loading />
                        :
                        filtered.length ?
                            <TilesList
                                items={filtered}
                                itemSize={64}
                                renderer={CustomerDebthTile(state.$.selected)}
                                selectedItem={state.selected}
                            />
                            :
                            <Flex center stretch>
                                <Typography variant="h4">No results found.</Typography>
                            </Flex>
                    }
                </>
            }>
            {state.selected ? <CustomerDebthList customerDebth={state.selected} />
                : <Flex center stretch>
                    Select the customer
                </Flex>
            }
        </Page>
        :
        <Loading />
}

const sortSummaryOptions = {
    amount: 'Amount',
    overdueAmount: 'OverDue Amount',
    customerName: ' Company Name'
};

const VerticalSpace = div({
    height: 8
})

const CustomerDebthTile = $selected => ({ data, style, index }) => {
    const debth = data.items[index] as DebthSummary;

    return (
        <div style={style}>
            <SmallTile
                color={localUserInfo.isCustomer(debth.relationship.id) ? 'yellow' : 'green'}
                isSelected={$selected.value === debth}

                onClick={e => {
                    $selected.set(debth);
                }}

                footer={
                    <>
                        <div>{localUserInfo.isCustomer(debth.relationship.id) ? debth.relationship.supplier.name : debth.relationship.customer.name}</div>
                        <Flex grow />
                        {debth.relationship.Customer.externalRelationshipId}
                    </>
                }
            >
                {asCurrency(debth.amount)} ({debth.count})
                <Flex grow />
                Overdue {asCurrency(debth.overdueAmount)} ({debth.overdueCount})
            </SmallTile>
        </div>
    )
}
